<template>
	<v-popover
		class="xs-5 flex xs-right"
		placement="bottom-end"
		popoverClass="xs-12 r2"
		popoverArrowClass="xs-0"
		popoverInnerClass="xs-12 r2 bg5 b1 bc7"
	>
		<crm-icon :color="isSelected ? 'c5' : 'c1'" name="kebab" size="normal" />
		<!-- context menu -->
		<div class="xs-12 cu2" slot="popover">
			<div
				v-can="'writeFiles'"
				v-if="item.type === 'file'"
				@click="$emit('item:rename')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
			>
				{{ $t("rename") }}
			</div>
			<div
				v-if="item.type === 'file'"
				@click="$emit('item:download')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
			>
				{{ $t("download") }}
			</div>
			<div
				v-can="'writeFiles'"
				v-if="item.type === 'file'"
				@click="$emit('item:privacy')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
			>
				{{ $t("edit_privacy_level") }}
			</div>
			<div
				v-can="'writeFiles'"
				v-if="item.type === 'file'"
				@click="$emit('item:cut')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
			>
				{{ $t("cut") }}
			</div>
			<div
				v-if="item.type === 'folder'"
				@click="$emit('item:open')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
			>
				{{ $t("open_folder") }}
			</div>
			<div
				v-if="item.type === 'folder'"
				@click="$emit('item:paste')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
				:class="cutItem ? 'c1 cu2' : 'c7 cu1'"
			>
				{{ $t("paste_inside") }}
			</div>
			<div
				v-can="'writeFiles'"
				@click="$emit('item:delete')"
				class="flex xs-12 p1 cError menu-item"
			>
				{{ $t("delete") }}
			</div>
		</div>
	</v-popover>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"

export default {
	name: "FileBrowserContextMenu",

	components: {
		CrmIcon
	},

	props: {
		item: Object,
		isSelected: Boolean,
		cutItem: Boolean
	}
}
</script>

<style scoped>
.menu-item:hover {
	background-color: rgb(248, 248, 249);
}
</style>
